import { useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { Stack } from '@mui/material';
import PageLayout from '../components/global/PageLayout';
import { isUserAdminOrManager } from '../utils/global/helper';
import useUser from '../hooks/global/useUser';
import useGetMarketingData from '../hooks/marketing/useGetMarketingData';
import CampaignsTable from '../components/marketing/CampaignsTable';
import CampaignEditorModal from '../components/marketing/CampaignEditorModal';
import MarketingCredits from '../components/marketing/MarketingCredits';
import useBusiness from '../hooks/businesses/useBusiness';
import useSubscriptionUpsell from '../hooks/subscriptions/useSubscriptionUpsell';
import { Feature } from '../types/subscriptions';

function MarketingPage() {
  const { user } = useUser();
  const { isFetching } = useGetMarketingData();
  const { isIndependent } = useBusiness();
  const { requireUpsell, upsell } = useSubscriptionUpsell(Feature.MARKETING);

  const [isNewModalOpen, setIsNewModalOpen] = useState(false);

  const onOpenNewModal = () => {
    if (requireUpsell) {
      upsell();
      return;
    }
    setIsNewModalOpen(true);
  };

  return (
    <PageLayout
      title="Marketing"
      isLoading={isFetching}
      guard={{
        isAllowed:
          !!user &&
          (isIndependent || isUserAdminOrManager(user)) &&
          user.canManageCampaigns,
      }}>
      <Stack
        direction="row"
        display="flex"
        justifyContent="space-between"
        gap={1}
        alignItems="end"
        flexWrap="wrap">
        <MarketingCredits />
        <LoadingButton
          variant="contained"
          className="primary"
          onClick={onOpenNewModal}>
          <span>New Campaign</span>
        </LoadingButton>
      </Stack>
      <CampaignsTable />
      <CampaignEditorModal
        key={isNewModalOpen.toString()}
        isOpen={isNewModalOpen}
        onClose={() => setIsNewModalOpen(false)}
      />
    </PageLayout>
  );
}

export default MarketingPage;
